import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const EditBankLawyer = (props) => {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [lawyerOptions, setLawyerOptions] = useState([]);
  const [bankLawyers, setBankLawyers] = useState([]);
  const [lawyerTable, setLawyerTable] = useState(
    props.client.lawyer_bank === undefined || props.client.lawyer_bank === null
      ? []
      : props.client.lawyer_bank.split(",")
  );

  const fetchBanks = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getBankLawyer", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBankLawyers(data);
        setLawyerOptions(createLawyerOptions(data));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchBanks();
  };

  useEffect(() => {
    getData();
  }, []);

  const addClient = async (e) => {
    if (value === "") {
      return;
    }
    if (lawyerTable.filter((el) => el === value).length > 0) {
      MySwal.fire({
        icon: "error",
        title: "Podano",
        text: "tego samego pełnomocnika",
      }).then(async (result) => {});
    } else {
      lawyerTable.push(value);
      setValue("");
    }
  };

  const deleteClient = async (e) => {
    setLawyerTable(lawyerTable.filter((el) => el !== e.target.value));
  };

  const generateLawyers = () => {
    var ret = "";
    lawyerTable.map((el, index) => {
      if (index === 0) {
        ret = ret + el;
      } else {
        ret = ret + ", " + el;
      }
    });

    return ret;
  };

  const editClient = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        clientId: props.client.id,
        field: "lawyer_bank",
        value: generateLawyers(),
      };

      fetch("https://apidevkppp.ftpeople.pl/updateFieldClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano informację o pełnomocniku banku",
        props.client.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "sprawę",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (true) {
      return true;
    } else {
      return false;
    }
  };

  const createLawyerOptions = (data) => {
    var bankOptions = [];
    bankOptions.push({ label: "brak danych", value: "brak danych" });
    data.map((el) => {
      bankOptions.push({ label: el.name, value: el.name });
    });

    return bankOptions;
  };

  return (
    <div style={{ width: "40vw" }} className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_2">
              <label>
                Pełnomocnik banku <span className="requiredStar">*</span>
              </label>
              <Select
                noOptionsMessage={() => "Brak danych"}
                placeholder={"Wybierz..."}
                isClearable={false}
                value={
                  value === ""
                    ? { label: "Wybierz...", value: "Wybierz..." }
                    : { label: value, value: value }
                }
                options={lawyerOptions}
                onChange={(e) => setValue(e.value)}
              />
            </div>
            <div
              style={{ display: "flex", alignItems: "end" }}
              className="inputCol_2"
            >
              <button className="paymentMenuButton" onClick={addClient}>
                DODAJ
              </button>
            </div>
          </div>
          <div style={{ marginTop: "3vh" }}>
            {lawyerTable.map((el) => (
              <>
                <div style={{ display: "flex", gap: "10px", marginTop: "1vh" }}>
                  <div style={{ width: "80%" }}>{el}</div>
                  <div style={{ width: "20%" }}>
                    <button
                      className="paymentMenuButton"
                      value={el}
                      onClick={deleteClient}
                    >
                      USUŃ
                    </button>
                  </div>
                </div>
              </>
            ))}
          </div>
          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditBankLawyer;
